<template>
  <v-container>
    <v-row>
      <v-col>
        <ContentView contentKey="RACER_REWARDS_SITE_AGREEMENT" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-btn :loading="loading" @click="onPrevious"> <v-icon left>mdi-arrow-left</v-icon> Back </v-btn>
      </v-col>
      <v-col class="text-right">
        <v-btn
          :rules="[v => !!v || 'You must accept the agreements']"
          :loading="loading"
          color="primary"
          @click="onNext"
        >
          I Agree, Next <v-icon right>mdi-arrow-right</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ContentView from "../../gapp-components/components/common/content/ContentView.vue";
export default {
  components: { ContentView },
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    onPrevious() {
      this.$emit("previous");
    },
    onNext() {
      this.$emit("next");
    }
  },
  mounted() {
    this.$content.refreshContent();
  }
};
</script>
